import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Message, SpinnerService } from 'shared-components';
import { EtiquetadoService } from "../../../services/etiquetado.service";

@Component({
    selector: 'app-confecciones-pallet-duplicar',
    templateUrl: './confecciones-pallet-duplicar.component.html'
})
export class ConfeccionesPalletDuplicarComponent implements OnInit {

    public showError: boolean;
    public mensajes = new Array<Message>();

    public confeccionPalletId;

    public pestanaActiva;

    public orderBy: string;
    public idColumn: number;
    public columnFilter: string;

    public selectedItems = [];
    public selectedConfecciones = [];

    @Input() confeccionesPallet;
    @Input() set onApplyFilters(value: boolean) {
      if(value && this.selectedItems.length != 0) this.cleanAll();
    };
    @Input() set onChangeTab(value: boolean) {
      if(value) this.cleanAll();
    };

    @Output() refresh = new EventEmitter<boolean>();
    @Output() sort = new EventEmitter<object>();

    @Output() confeccionesSelected = new EventEmitter<Array<any>>();
    @Output() multipleConfecciones = new EventEmitter<boolean>();

    constructor(
        private readonly _translate: TranslateService,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService
    ) {}

    ngOnInit() {
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public close() {
    }

    public pushMessage(mensaje) {
        this.showError = true;
        this.mensajes.push({ class: 'success', message: mensaje });
    }

    public toRefresh(value) {
        if (value) {
            this.refresh.emit(true);
        }
    }

    public toOrderBy(columnFilter, idColumn){
      this.idColumn = idColumn;
      this.columnFilter = columnFilter;
      this.orderBy = !this.orderBy || this.orderBy == 'DESC' ? 'ASC' : 'DESC';
      this.sort.emit({columnFilter: columnFilter, idColumn: idColumn});
    }

    public getIcon(prop: string, idColumn: number) {
      let iconClass = 'fa fa-sort';
      if (this.idColumn && this.columnFilter && this.idColumn === idColumn && this.columnFilter === prop){
        iconClass = this.orderBy === 'DESC' ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public get allChecked(): boolean {
      let isAllChecked = true;
      this.confeccionesPallet.forEach(confeccion => {
          if (!this.selectedItems.includes(confeccion.id)) {
              isAllChecked = false;
          }
      });
      return isAllChecked;
    }

    public selectConfeccion(confeccion, value: boolean, all?: boolean) {
      if (value) {
          if (!this.selectedItems.includes(confeccion.id)) {
              this.selectedItems.push(confeccion.id);
              this.selectedConfecciones.push(confeccion);
          }
      } else {
          if (this.selectedItems.includes(confeccion.id)) {
              this.selectedItems.splice(this.selectedItems.indexOf(confeccion.id), 1);
              this.selectedConfecciones.splice(this.selectedItems.indexOf(confeccion.id), 1);
          }
      }

      if (!all) {
          this.multipleConfecciones.emit(this.selectedItems.length > 0);
          this.confeccionesSelected.emit(this.selectedConfecciones);
      }
    }

    public selectAll(value: boolean) {
      this.confeccionesPallet.forEach(confeccion => {
          this.selectConfeccion(confeccion, value, true);
      });
      this.multipleConfecciones.emit(value);
      this.confeccionesSelected.emit(this.selectedConfecciones);
    }

    public cleanAll(){
      this.selectAll(false);
      this.selectedItems = [];
      this.selectedConfecciones = [];
      this.confeccionesSelected.emit(this.selectedConfecciones);
    }

    public trackByConfeccionPalletId(index: number, confeccionPallet: { id: number }): number {
      return confeccionPallet.id;
    }
}
